import { isCloud } from '@blk/aw-env-detection';
import { awSettings } from './Base';

export const isAGraphEnabled = () => {
  // Temporarily only using AGraph APIs externally until the legacy internal ones are fixed by AGraph team
  if (isCloud()) {
    return awSettings.getAGraphConfig?.()?.aladdinwealth ?? false;
  }
  return false;
};
